module.exports = __webpack_public_path__ + "static/media/Visuel4.48dec841.jpg";